import Scrollbar from './main'

Scrollbar.install = function(Vue) {
  Vue.component(Scrollbar.name, Scrollbar)
}

export default Scrollbar